var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponsiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0982 5.12256V1.15879C15.0982 0.824543 14.8343 0.550293 14.5033 0.550293H1.18057C0.853785 0.550293 0.589844 0.820258 0.589844 1.15879V5.15255C0.589844 5.48679 0.853785 5.76104 1.18476 5.76104H14.4824C14.8091 5.76104 15.0773 6.03101 15.0773 6.36954L15.0898 11.0503L15.5 11.5L28.5898 11.5503C28.9166 11.5503 29.5898 10.6718 29.5898 10.3333V6.33954C29.5898 6.0053 29.3259 5.73105 28.9949 5.73105H15.6973C15.3705 5.73105 15.1024 5.46108 15.1024 5.12256H15.0982Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5126 15.4V11.5856C14.5126 11.2639 14.2486 11 13.9177 11H0.594915C0.268131 11 0 11.2598 0 11.5856V15.4289C0 15.7505 0.263941 16.0144 0.594915 16.0144H13.8925C14.2193 16.0144 14.4874 16.2742 14.4874 16.6V20.4144C14.4874 20.7361 14.7514 21 15.0823 21H28.4051C28.7319 21 29 20.7402 29 20.4144V16.5711C29 16.2495 28.7361 15.9856 28.4051 15.9856H15.1075C14.7807 15.9856 14.5126 15.7258 14.5126 15.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveIcon);
export default __webpack_public_path__ + "static/media/responsive_icon.32353997b7ae2ff5def6e020dcb8a8ee.svg";
export { ForwardRef as ReactComponent };